import { useState } from 'react';
//import { ErrorMessage } from 'formik';
import DatePicker from 'react-datetime-picker';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import styled from 'styled-components';
import { fontFamily } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import { theme } from '../../../theme';
import { Box } from '../';
import { StyledSystemProps } from '../../../theme/StyledSystemProps';
import { Label } from '../../../typography';

type State = {
  startDate: Date | null;
  endDate: Date | null;
};

type Props = StyledSystemProps & {
  isSingleDate?: boolean;
  maxDate?: string | Date;
  minDate?: string | Date;
  name: string;
  label?: string;
  color?: string;
  disabled?: boolean;
  startDate?: Date;
  endDate?: Date;
  bg?: string;
  setStartDate: (startDate: Date | null) => void;
  setEndDate: (endDate: Date | null) => void;
};

const DatePickerWrapper = styled.div<StyledSystemProps>`
  width: 100%;
  .react-date-picker,
  .react-datetime-picker,
  .react-daterange-picker {
    background-color: #fff;
    height: 40px;
    top: 2px;
    display: flex;
    font-weight: 400;
    border-radius: 4px;
    color: ${themeGet('colors.primary', '#222429')};
    font-size: ${themeGet('fontSize[1]', '16px')};
  }
  .react-date-picker > .react-date-picker__wrapper,
  .react-datetime-picker > .react-datetime-picker__wrapper,
  .react-daterange-picker > .react-daterange-picker__wrapper {
    border-radius: 4px;
    border: 1px solid rgba(50, 50, 93, 0.2);
  }
  .react-calendar {
    border-radius: 4px;
    border: 1px solid rgba(50, 50, 93, 0.2);
    color: ${themeGet('colors.primary', '#222429')};
    font-size: ${themeGet('fontSize[1]', '16px')};
    ${fontFamily};
    padding: 10px;

    z-index: ${theme.zIndex[15]};
    position: fixed;
    box-sizing: border-box;
  }
`;

const StyledDatePicker = ({ isSingleDate, name, label, setEndDate, setStartDate, ...rest }: Props) => {
  const [state, setState] = useState<State>({
    startDate: rest.startDate ? rest.startDate : null,
    endDate: rest.endDate ? rest.endDate : null,
  });

  return (
    <Box {...rest}>
      {!!label ? <Label htmlFor={name}>{label}</Label> : null}
      <DatePickerWrapper>
        {isSingleDate ? (
          <DatePicker
            disabled={rest.disabled}
            format="M/d/y"
            value={rest.startDate}
            maxDate={rest.maxDate ? new Date(rest.maxDate) : undefined}
            minDate={rest.minDate ? new Date(rest.minDate) : undefined}
            onChange={(date: any) => setStartDate(date)}
          />
        ) : (
          <DateRangePicker
            disabled={rest.disabled}
            maxDate={rest.maxDate ? new Date(rest.maxDate) : undefined}
            minDate={rest.minDate ? new Date(rest.minDate) : undefined}
            value={[state.startDate, state.endDate]}
            onChange={(args: Date[]) => {
              console.log('args', args);
              setEndDate(args && args[1]);
              setStartDate(args && args[0]);
              return setState(Object.assign({}, state, { startDate: args && args[0], endDate: args && args[1] }));
            }}
          />
        )}
      </DatePickerWrapper>
      {/* <ErrorMessage name={name}>
        {msg => (
          <Span mt={2} color="error" textAlign="right">
            {msg}
          </Span>
        )}
      </ErrorMessage> */}
    </Box>
  );
};

StyledDatePicker.defaultProps = {
  mb: 4,
  flex: 1,
  minWidth: '150px',
};

export default StyledDatePicker;
